import { render } from "./ListPagination.vue?vue&type=template&id=68ddcad9&scoped=true"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=68ddcad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ddcad9"]])

export default __exports__